import { Flex, Toggle } from '@components';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  margin: theme.spacing(14, 0),
  gap: theme.spacing(12),
  width: '100%',
  flexDirection: 'column',
}));

export const StyledNotificationContainer = styled(Flex, {
  shouldForwardProp: (prop) => prop !== 'hideBottomBorder',
})<{ hideBottomBorder: boolean }>(({ theme, hideBottomBorder }) => ({
  borderBottom: hideBottomBorder
    ? 'none'
    : `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(6, 0),
}));

export const StyledNotificationToggle = styled(Toggle)(({ theme }) => ({
  marginLeft: 0,
  display: 'flex',
  flex: 1,
  justifyContent: 'flex-end',
  gap: theme.spacing(8),
  '.MuiFormControlLabel-label': {
    maxWidth: 200,
    wordBreak: 'break-word',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 120,
    },
  },
  '.MuiSwitch-root': {
    marginLeft: 0,
    flex: 3,
    maxWidth: 32,
  },
}));
